import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { ArrowRight, Award, Instagram } from "lucide-react";
import VeteranBadge from "@/components/VeteranBadge";
import { resolveImage } from "@/lib/siteDefaults";

export default function ComingSoon() {
  const { site } = useSite();
  const p = site.prelaunch || {};
  const handle = (site.instagram?.handle || "").replace(/^@/, "");
  const heroImg = site.hero?.image;

  return (
    <div className="relative min-h-screen bg-[#F9F9F6] overflow-hidden">
      {heroImg && (
        <div className="absolute inset-0">
          <img src={resolveImage(heroImg)} alt="" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#F9F9F6]/40 via-[#F9F9F6]/70 to-[#F9F9F6]" />
        </div>
      )}

      <div className="relative min-h-screen flex flex-col">
        <div className="p-6 md:p-10 lg:p-14 flex items-center justify-between">
          <Link to="/" className="font-serif text-2xl md:text-3xl tracking-tight text-[#1A1C1A] font-light">
            Jenova <span className="italic font-light text-stone-500">Collective</span>
          </Link>
          {handle && (
            <a
              href={`https://instagram.com/${handle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-stone-500 hover:text-[#1A1C1A] transition-colors"
            >
              <Instagram strokeWidth={1.5} className="w-3.5 h-3.5" /> @{handle}
            </a>
          )}
        </div>

        <div className="flex-1 flex items-center justify-center px-6 md:px-10 pb-14">
          <div className="max-w-3xl text-center fade-up">
            <VeteranBadge className="mb-8" />
            <p className="text-xs uppercase tracking-[0.35em] text-stone-500 font-semibold mb-6">{p.overline}</p>
            <h1 className="font-serif font-light text-[#1A1C1A] text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] leading-[0.9] tracking-tighter">
              {p.title_line_1} <em className="italic text-stone-500">{p.title_em}</em>
              <br />{p.title_line_3}
            </h1>
            <p className="mt-10 max-w-xl mx-auto text-lg text-stone-600 font-light leading-relaxed">
              {p.subtitle}
            </p>
            <Link
              to={p.cta_href || "/founding"}
              data-testid="prelaunch-cta"
              className="mt-10 inline-flex items-center gap-2 bg-[#1A1C1A] text-[#F9F9F6] hover:bg-[#3C3E3C] px-10 py-4 rounded-full transition-all duration-300 font-sans text-sm tracking-wider uppercase"
            >
              <Award strokeWidth={1.75} className="w-4 h-4" /> {p.cta_label || "Reserve your founding spot"}
              <ArrowRight strokeWidth={1.75} className="w-4 h-4" />
            </Link>
            <p className="mt-6 text-xs uppercase tracking-[0.25em] text-stone-500">Only 100 spots · 15% off forever</p>
          </div>
        </div>

        <div className="p-6 md:p-10 lg:p-14 text-center text-xs text-stone-500 font-sans">
          © {new Date().getFullYear()} Jenova Collective — jenovacollective.co
        </div>
      </div>
    </div>
  );
}
